// extracted by mini-css-extract-plugin
export default {"input":"Input_input__Miuzo","disabled":"Input_disabled__6c3Rk","error":"Input_error__ambPV","readOnly":"Input_readOnly__aXlY1","infomat":"Input_infomat__AgZ-4"};